import type { ReactElement } from "react";
import { TextFeld, feldId } from "./felder.js";
import { mitWert, wertAn } from "../layoutEntwurf.js";
import type { PanelProps } from "../LayoutRegister.js";

/**
 * Register „Texte": die Titel der Belegart, die das Blatt gerade zeigt, und die
 * Rückfalltexte. Die Korrekturrechnung ERBT die Titel der Rechnung ausser dem Betreff
 * (`erbtVon` im Katalog, docs/sektionen.md): Ihr Platzhalter ist dann der Wert, den die
 * Rechnung im Entwurf hat — genau das, was die Engine drucken würde.
 */
/** Höchstlänge eines Rückfalltexts — die Grenze der Whitelist (Fixrunde 1, W1). */
const TEXT_MAX = 2000;

export function TextePanel(p: PanelProps): ReactElement {
  const k = p.stand.katalog;
  const art = k.belegarten.find((b) => b.art === p.belegart) ?? k.belegarten[0];
  const erbe = art === undefined || art.erbtVon === null ? null
    : k.belegarten.find((b) => b.art === art.erbtVon) ?? null;
  return (
    <div className="lay__panel">
      {art !== undefined && (
        <fieldset className="lay__gruppe">
          <legend>Titel für {art.label}</legend>
          {erbe !== null && (
            <p className="lay__panelhinweis">Erbt von {erbe.label} — ein leerer Titel
              übernimmt deren Wert, der Betreff bleibt eigen.</p>
          )}
          {art.titel.map((t) => {
            const pfad = ["belegarten", art.art, t.schluessel];
            const geerbt = erbe !== null && t.schluessel !== "betreff"
              ? wertAn(p.entwurf, ["belegarten", erbe.art, t.schluessel]) : undefined;
            return (
              <TextFeld key={t.schluessel} id={feldId(pfad.join("."))} label={t.label}
                wert={wertAn(p.entwurf, pfad)} mehrzeilig={false}
                systemwert={typeof geerbt === "string" ? geerbt : t.vorgabe}
                hinweis={typeof geerbt === "string" && erbe !== null
                  ? `geerbt von ${erbe.label}` : undefined}
                fehler={p.feldFehler[pfad.join(".")]}
                onWert={(neu) => p.onEntwurf(mitWert(p.entwurf, pfad, neu))}
                onVerlassen={p.onFeldVerlassen} />
            );
          })}
        </fieldset>
      )}
      <fieldset className="lay__gruppe">
        <legend>Rückfalltexte</legend>
        <p className="lay__panelhinweis">Gelten, wenn der Beleg keinen eigenen Text trägt.
          Die Fußzeile ist einzeilig.</p>
        {k.texte.map((t) => (
          <TextFeld key={t.id} id={feldId(`texte.${t.id}`)} label={t.label}
            wert={wertAn(p.entwurf, ["texte", t.id])} systemwert={t.wert}
            mehrzeilig={t.mehrzeilig} fehler={p.feldFehler[`texte.${t.id}`]}
            max={TEXT_MAX} markdown
            onWert={(neu) => p.onEntwurf(mitWert(p.entwurf, ["texte", t.id], neu))}
            onVerlassen={p.onFeldVerlassen} />
        ))}
      </fieldset>
    </div>
  );
}
